import { BigNumber, Schema as Schema_ } from '@blade/std-lib'
import { Network } from '@root/entities/network/model'

const IconModerationStatusSchema = Schema_.Literals([
  'active',
  'restricted',
  'processing',
])

const ModerationReasonSchema = Schema_.Literals([
  'openai_flagged',
  'gemini_flagged',
  'fetch_failed',
  'no_onchain_logo',
  's3_not_found',
])

export const Schema = Schema_.Struct({
  address: Schema_.String,
  network: Network.Schema,
  ticker: Schema_.String,
  title: Schema_.String,
  decimals: Schema_.Number,
  reusedImageCount: Schema_.UndefinedOrFromOptional(Schema_.Number),
  imageHash: Schema_.UndefinedOrFromOptional(Schema_.String),
  icon: Schema_.UndefinedOrFromOptional(Schema_.String),
  iconStatus: Schema_.UndefinedOrFromOptional(IconModerationStatusSchema),
  moderationReason: Schema_.UndefinedOrFromOptional(ModerationReasonSchema),
  supply: BigNumber.FromString,
  updatedAt: Schema_.UndefinedOrFromOptional(Schema_.DateFromString),
})

export type CurrencySnapshot = Schema_.Schema.Type<typeof Schema>

export type Encoded = Schema_.Codec.Encoded<typeof Schema>

export const decodeUnknownOption = Schema_.decodeUnknownOption(Schema)
export const encodeSync = Schema_.encodeSync(Schema)
